module.exports = __webpack_public_path__ + "img/grp-part-4-corporate-3.e81cc3db.png";